export default "__VITE_ASSET__6dKJezt9__"